import { render, staticRenderFns } from "./CartHeader.vue?vue&type=template&id=67c1bd24&scoped=true&"
import script from "./CartHeader.vue?vue&type=script&lang=ts&"
export * from "./CartHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CartHeader.vue?vue&type=style&index=0&id=67c1bd24&scoped=true&lang=scss&"
import style1 from "./CartHeader.vue?vue&type=style&index=1&id=67c1bd24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c1bd24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
